<div class="full-width-image-section terms-top">
    <div class="arrow-up">
        <next-topbar></next-topbar>
        <next-menu></next-menu>

        <div class="container white">
            <div class="row">
                <div class="col-sm-12 text-center">
                    <h1>{{ 'PAGE.PRODUCT_INFORMATION.TITLE' | translate }}</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 col-sm-offset-4">
                    <div class="icon-bg center">
                        <div class="icon-wrap">
                            <i class="nf nf-terms-icon-v3"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="subpage">
    <div class="container">
        <div class="row">
            <div class="col-sm-4 text-center">
                <div class="insurance-container">
                    <div class="insurance-box insurance-img img-terms-car">
                        <div class="icon-circle center">
                            <div class="icon-wrap">
                                <i class="nf nf-car-icon-v3"></i>
                            </div>
                        </div>
                    </div>
                    <div class="insurance-bottom-box">
                        <h2>{{ 'INSURANCE.CAR.PRODUCT' | translate }} (NextBilPlus)</h2>
                        <a href="https://static.next.dk/website/productinformation/Personbilforsikringplus.pdf?v=261023" target="_blank">
                            <span class="text-green">{{ 'PAGE.PRODUCT_INFORMATION.DOWNLOAD_INFO' | translate }}</span>
                            <i class="nf-selvbetjening-pdf"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-sm-4 text-center">
                <div class="insurance-container">
                    <div class="insurance-box insurance-img img-terms-car">
                        <div class="icon-circle center">
                            <div class="icon-wrap">
                                <i class="nf nf-car-icon-v3"></i>
                            </div>
                        </div>
                    </div>
                    <div class="insurance-bottom-box">
                        <h2>{{ 'INSURANCE.CAR.PRODUCT' | translate }} (NextBil)</h2>
                        <a href="https://static.next.dk/website/productinformation/Personbilforsikring.pdf?v=261023" target="_blank">
                            <span class="text-green">{{ 'PAGE.PRODUCT_INFORMATION.DOWNLOAD_INFO' | translate }}</span>
                            <i class="nf-selvbetjening-pdf"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-sm-4 text-center">
                <div class="insurance-container">
                    <div class="insurance-box insurance-img img-terms-house">
                        <div class="icon-circle center">
                            <div class="icon-wrap">
                                <i class="nf nf-house-icon-v3"></i>
                            </div>
                        </div>
                    </div>
                    <div class="insurance-bottom-box">
                        <h2>{{ 'INSURANCE.HOUSE.PRODUCT' | translate }}</h2>
                        <a href="https://static.next.dk/website/productinformation/Husforsikring.pdf?v=261023" target="_blank">
                            <span class="text-green">{{ 'PAGE.PRODUCT_INFORMATION.DOWNLOAD_INFO' | translate }}</span>
                            <i class="nf-selvbetjening-pdf"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 text-center">
                <div class="ribbon-parent insurance-container">
                    <div class="insurance-box insurance-img img-terms-home">
                        <div class="icon-circle center">
                            <div class="icon-wrap">
                                <i class="nf nf-home-icon-v3"></i>
                            </div>
                        </div>
                        <ribbon [type]="'travel'"></ribbon>
                    </div>
                    <div class="insurance-bottom-box">
                        <h2>{{ 'INSURANCE.HOME.PRODUCT' | translate }}</h2>
                        <a href="https://static.next.dk/website/productinformation/Indboforsikring.pdf?v=261023" target="_blank">
                            <span class="text-green">{{ 'PAGE.PRODUCT_INFORMATION.DOWNLOAD_INFO' | translate }}</span>
                            <i class="nf-selvbetjening-pdf"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-sm-4 text-center">
                <div class="insurance-container">
                    <div class="insurance-box insurance-img img-terms-accident">
                        <div class="icon-circle center">
                            <div class="icon-wrap">
                                <i class="nf nf-accident-icon-v3"></i>
                            </div>
                        </div>
                    </div>
                    <div class="insurance-bottom-box">
                        <h2>{{ 'INSURANCE.ACCIDENT.PRODUCT' | translate }}</h2>
                        <a href="https://static.next.dk/website/productinformation/Ulykkesforsikring.pdf?v=261023" target="_blank">
                            <span class="text-green">{{ 'PAGE.PRODUCT_INFORMATION.DOWNLOAD_INFO' | translate }}</span>
                            <i class="nf-selvbetjening-pdf"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-sm-4 text-center">
                <div class="insurance-container">
                    <div class="insurance-box insurance-img img-terms-accident">
                        <div class="icon-circle center">
                            <div class="icon-wrap">
                                <i class="nf nf-accident-icon-v3"></i>
                            </div>
                        </div>
                    </div>
                    <div class="insurance-bottom-box">
                        <h2>{{ 'PAGE.PRODUCT_INFORMATION.CHILD_ACCIDENT' | translate }}</h2>
                        <a href="https://static.next.dk/website/productinformation/Børneulykkesforsikring.pdf?v=261023" target="_blank">
                            <span class="text-green">{{ 'PAGE.PRODUCT_INFORMATION.DOWNLOAD_INFO' | translate }}</span>
                            <i class="nf-selvbetjening-pdf"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-sm-4 text-center">
                <div class="insurance-container">
                    <div class="insurance-box insurance-img img-terms-dog">
                        <div class="icon-circle center">
                            <div class="icon-wrap">
                                <i class="nf nf-dog-icon-v3"></i>
                            </div>
                        </div>
                    </div>
                    <div class="insurance-bottom-box">
                        <h2>{{ 'INSURANCE.DOG.PRODUCT' | translate }}</h2>
                        <a href="https://static.next.dk/website/productinformation/Hundeforsikring.pdf?v=261023" target="_blank">
                            <span class="text-green">{{ 'PAGE.PRODUCT_INFORMATION.DOWNLOAD_INFO' | translate }}</span>
                            <i class="nf-selvbetjening-pdf"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 text-center">
                <div class="insurance-container">
                    <div class="insurance-box insurance-img img-terms-caravan">
                        <div class="icon-circle center">
                            <div class="icon-wrap">
                                <i class="nf nf-caravan-icon-v3"></i>
                            </div>
                        </div>
                    </div>
                    <div class="insurance-bottom-box">
                        <h2>{{ 'INSURANCE.CARAVAN.PRODUCT' | translate }}</h2>
                        <a href="https://static.next.dk/website/productinformation/Campingvognsforsikring.pdf?v=261023" target="_blank">
                            <span class="text-green">{{ 'PAGE.PRODUCT_INFORMATION.DOWNLOAD_INFO' | translate }}</span>
                            <i class="nf-selvbetjening-pdf"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-sm-4 text-center">
                <div class="insurance-container">
                    <div class="insurance-box insurance-img img-terms-secondhouse">
                        <div class="icon-circle center">
                            <div class="icon-wrap">
                                <i class="nf nf-secondhouse-icon-v3"></i>
                            </div>
                        </div>
                    </div>
                    <div class="insurance-bottom-box">
                        <h2>{{ 'INSURANCE.SECONDHOUSE.PRODUCT' | translate }}</h2>
                        <a href="https://static.next.dk/website/productinformation/Fritidshusforsikring.pdf?v=261023" target="_blank">
                            <span class="text-green">{{ 'PAGE.PRODUCT_INFORMATION.DOWNLOAD_INFO' | translate }}</span>
                            <i class="nf-selvbetjening-pdf"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 text-center">
                <div class="insurance-container">
                    <div class="insurance-box insurance-img img-terms-moped">
                        <div class="icon-circle center">
                            <div class="icon-wrap">
                                <i class="nf nf-moped-icon-v3"></i>
                            </div>
                        </div>
                    </div>
                    <div class="insurance-bottom-box">
                        <h2>{{ 'INSURANCE.MOPED.PRODUCT' | translate }}</h2>
                        <a href="https://static.next.dk/website/productinformation/Knallertforsikring.pdf?v=261023" target="_blank">
                            <span class="text-green">{{ 'PAGE.PRODUCT_INFORMATION.DOWNLOAD_INFO' | translate }}</span>
                            <i class="nf-selvbetjening-pdf"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<trustpilot-carousel></trustpilot-carousel>

<next-footer></next-footer>
